import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Installs the toast-override wrapper (side-effect) and lets us load custom copy.
import { loadToastOverrides } from "@/lib/toastOverrides";
import App from "@/App";

// Pull platform-wide custom toast copy once at startup (public + cosmetic; if it
// fails, every message just shows its built-in default).
loadToastOverrides();

// Build version: 2026-03-16-v2 - Force cache invalidation

// Fix ResizeObserver loop error - this is a known harmless error
// that occurs with Radix UI components during rapid resize animations
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore ResizeObserver errors
        }
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
